module.exports = __webpack_public_path__ + "static/img/no-video.31db82b0.svg";